"use client";

import { useEffect, useRef } from "react";

type HubSpotMeetingsProps = {
  /**
   * HubSpot MeetingsのURL
   * 例: "https://meetings-na2.hubspot.com/tsubasa1/casual?embed=true"
   */
  meetingUrl: string;
  /**
   * 追加のクラス名
   */
  className?: string;
};

export default function HubSpotMeetings({
  meetingUrl,
  className,
}: HubSpotMeetingsProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    // スクリプトが既に読み込まれている場合はスキップ
    if (scriptLoadedRef.current) {
      return;
    }

    // HubSpot Meetingsスクリプトを動的に読み込み
    const script = document.createElement("script");
    script.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
    script.async = true;
    script.id = "hubspot-meetings-script";

    // 既に同じスクリプトが存在するかチェック
    const existingScript = document.getElementById(script.id);
    if (!existingScript) {
      document.body.appendChild(script);
      scriptLoadedRef.current = true;
    }

    // クリーンアップ関数
    return () => {
      // 他のページでも使用される可能性があるため、スクリプトは削除しない
      scriptLoadedRef.current = false;
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`meetings-iframe-container ${className || ""}`}
      data-src={meetingUrl}
    />
  );
}

